__turbopack_context__.v({
  "header": "RootView-module-scss-module__XtdqNa__header",
  "listContainer": "RootView-module-scss-module__XtdqNa__listContainer",
});
